import React, { useEffect, useState, useMemo } from "react";
import API from "../../Service/Baseservice";
import Loading from "../../../Loading/loading";

const EligibilityLabel = () => {
    const [labels, setLabels] = useState([]);
    const [languageId, setLanguageId] = useState(1);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [popup, setPopup] = useState({ show: false, title: "", message: "", type: "info" });

    const calculateTotalPointsFromMaxValues = useMemo(() => {
        let total = 0;
        labels.forEach((item) => {
            if (item.points_list && item.points_list.length > 0) {
                const maxPoints = Math.max(...item.points_list.map(p => Number(p.points || 0)));
                total += maxPoints;
            } else {
                total += Number(item.point || 0);
            }
        });
        return total;
    }, [labels]);

    const handleChildPointChange = (formId, pointId, value) => {
        const numericValue = value.replace(/[^0-9]/g, '');

        const cleanValue = numericValue === '' ? '' :
            numericValue.replace(/^0+(?!$)/, '') || '0';

        setLabels(prev =>
            prev.map((item) => {
                if (item.eligibility_form_id !== formId)
                    return item;
                return {
                    ...item,
                    points_list: item.points_list?.map((p) =>
                        p.eligibilitypoints_id === pointId ?
                            { ...p, points: cleanValue } : p),
                };
            }));
    };

    const fetchLabels = () => {
        setLoading(true);
        API.post("checkeligibilityformList/condition", { language_id: languageId })
            .then((res) => {
                const list = res.data?.data || [];
                const activeList = list.filter((item) => item.active !== 4);
                setLabels(activeList);
            })
            .catch((err) => console.error("Error:", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchLabels();
    }, [languageId]);

    const handleSubmit = () => {
        let hasInvalidInput = false;
        labels.forEach(item => {
            if (item.points_list) {
                item.points_list.forEach(p => {
                    const value = p.points;
                    if (value !== '' && isNaN(Number(value))) {
                        hasInvalidInput = true;
                    }
                });
            }
        });

        if (hasInvalidInput) {
            setPopup({
                show: true,
                title: "Validation Error",
                message: "Please enter valid numbers only.",
                type: "error",
            });
            return;
        }

        const totalPoints = calculateTotalPointsFromMaxValues;
        if (totalPoints !== 100) {
            setPopup({
                show: true,
                title: "Error",
                message: `Total points must equal 100. Current total: ${totalPoints}`,
                type: "error",
            });
            return;
        }

        setSaving(true);

        const updateList = [];

        labels.forEach(item => {
            if (item.points_list) {
                item.points_list.forEach(p => {
                    updateList.push({
                        eligibilitypoints_id: p.eligibilitypoints_id,
                        points: Number(p.points) || 0
                    });
                });
            }
        });

        const payload = {
            update_list: updateList
        };

        console.log("Submitting ALL points payload:", payload);

        API.post("checkeligibilityformUpdate/update", payload)
            .then((res) => {
                if (res.data?.status === "success") {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: "Points updated successfully!",
                        type: "success",
                    });
                    fetchLabels();
                } else {
                    const message = res.data?.error?.message || "Failed to update points.";
                    setPopup({
                        show: true,
                        title: "Error",
                        message: message,
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.error(err);
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Something went wrong. Please try again.",
                    type: "error",
                });
            })
            .finally(() => setSaving(false));
    };

    return (
        <div className="admin-container">
            <div className="eligibility-label-header">
                <h2 className="news-title">Eligibility Label List</h2>

                <div className="eligibility-label-right-actions">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={languageId}
                                onChange={(e) => setLanguageId(Number(e.target.value))}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {/* TABLE */}
            <div className="admin-table-wrapper">
                {loading ? (
                    <Loading />
                ) : (
                    <table className="eligibility-table">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th>Points Name</th>
                                <th>Points</th>
                            </tr>
                        </thead>

                        <tbody>
                            {labels.length > 0 ? (
                                labels.map((item) => {
                                    if (item.points_list && item.points_list.length > 1) {
                                        return (
                                            <React.Fragment key={item.eligibility_form_id}>

                                                <tr className="group-header-row">
                                                    <td rowSpan={item.points_list.length}>
                                                        <strong>{item.label}</strong>
                                                    </td>
                                                    <td>{item.points_list[0].points_name}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            value={item.points_list[0].points ?? ""}
                                                            className="points-input"
                                                            onChange={(e) =>
                                                                handleChildPointChange(
                                                                    item.eligibility_form_id,
                                                                    item.points_list[0].eligibilitypoints_id,
                                                                    e.target.value
                                                                )
                                                            }
                                                            onInput={(e) => {
                                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                            }}
                                                        />
                                                    </td>
                                                </tr>


                                                {item.points_list.slice(1).map((p) => (
                                                    <tr key={p.eligibilitypoints_id} className="group-detail-row">
                                                        <td>{p.points_name}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                value={p.points ?? ""}
                                                                className="points-input"
                                                                onChange={(e) =>
                                                                    handleChildPointChange(
                                                                        item.eligibility_form_id,
                                                                        p.eligibilitypoints_id,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                onInput={(e) => {
                                                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        );
                                    } else {
                                        return (
                                            <tr key={item.eligibility_form_id}>
                                                <td><strong>{item.label}</strong></td>
                                                <td>
                                                    {item.points_list?.[0]?.points_name || item.label}
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.points_list?.[0]?.points ?? ""}
                                                        className="points-input"
                                                        onChange={(e) =>
                                                            handleChildPointChange(
                                                                item.eligibility_form_id,
                                                                item.points_list?.[0]?.eligibilitypoints_id,
                                                                e.target.value
                                                            )
                                                        }
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    }
                                })
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: "center" }}>
                                        No labels found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <div style={{ marginTop: "20px", textAlign: "right" }}>
                <button
                    className="add-btn"
                    onClick={handleSubmit}
                    disabled={saving}
                    style={{ padding: "10px 20px" }}
                >
                    {saving ? "Save Changes" : "Save Changes"}
                </button>
            </div>

            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button className="btn ok-btn" onClick={() => setPopup({ ...popup, show: false })}>OK</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EligibilityLabel;